<nav class="navbar navbar-default navbar-expand-lg fixed-top d-block d-print-none bg-white" [ngClass]="{'offline': offline}">
    <div class="row px-7" style="margin-top: 9px">
        <div class="col-auto pe-0 order-0">
            <h1 class="navbar-brand me-5 float-start my-1">
                {{Title}}
            </h1>
        </div>
        <div class="col-lg-auto col-12 d-lg-flex collapse order-lg-1 ps-0 order-2 " id="action-filter">
            <div class="search-box">
                <div class="d-flex h-100 align-items-center justify-content-lg-start justify-content-end">
                    <div>
                        <form #form="ngForm" (ngSubmit)="submit()">
                            <div class="input-group">
                                <ng-container *ngIf="filterAutoComplete">
                                    <autocompleteV2 [requestUrl]="requestUrl" [customClass]="'autocomplete-mainpanel'"
                                        (optionSelected)="onAutoCompleteChange($event)"
                                        (onInputEnter)="onAutoCompleteEnter($event)"
                                        [placeholder]="searchBoxPlaceholder || 'Search..'"
                                        [inputTextValue]="text"
                                        class="input-left">
                                    </autocompleteV2>
                                    <div >
                                        <button class="btn btn-outline-secondary fw-bold rounded-0 border-start-0" type="button"
                                            (click)="submit()"><i class="fa fa-search"></i></button>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="!hideSearchBox">
                                    <input type="text" [ngModelOptions]="{standalone: true}" class="form-control input"
                                        style="width:9.375rem;font-size:1rem;" [(ngModel)]="text"
                                        (keyup)="onTextChange()" placeholder="{{searchBoxPlaceholder}}">
                                    <div >
                                        <button class="btn btn-outline-secondary fw-bold rounded-0 border-start-0" type="button"
                                            (click)="submit()"><i class="fa fa-search"></i></button>
                                    </div>
                                </ng-container>
                                
                                <ng-container *ngIf="showBarcodeScanner">
                                    <input type="text" [ngModelOptions]="{standalone: true}" class="form-control input"
                                        style="width:9.375rem;font-size:1rem;" [(ngModel)]="barcodeQuery"
                                        (keyup.enter)="onBarcodeQueryChange()" placeholder="Barcode Counter">
                                    <div >
                                        <button class="btn btn-outline-secondary fw-bold" type="button"
                                            (click)="onBarcodeQueryChange()"><i class="fa fa-barcode"></i></button>
                                    </div>
                                </ng-container>
                                
                            </div>
                        </form>
                    </div>
                    <div class="dropdown text-secondary ps-5" *ngIf="!hideSearchDropdown">
                        <a id="dropdown-filter" role="button" class="text-muted h5" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                            <i class="fa fa-filter"><i class="fa-solid fa-caret-down"></i></i>
                        </a>
                        <form class="dropdown-menu p-3" style="left: auto !important" [style]="{'width':filterWidth }"
                            (click)="toggleDropdown($event);">
                            <ng-content select="[filters]"></ng-content>
                            <button class="btn btn-outline-secondary" (click)="submit()" title="Click to filter!">
                                <i class="fa-solid fa-search pointer me-1"></i>Search
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="col d-lg-none d-flex justify-content-end align-items-center order-lg-2 order-1">
            <button class="btn btn-lg btn-outline-secondary d-lg-none me-2" type="button" data-bs-toggle="collapse"
                data-bs-target="#action-button" aria-expanded="false" aria-controls="collapseExample">
                <i class="fa-solid fa-sort-down" aria-hidden="true"></i>
            </button>
            <button class="btn btn-lg btn-outline-secondary d-lg-none me-2" type="button" data-bs-toggle="collapse"
                data-bs-target="#action-filter" aria-expanded="false" aria-controls="collapseExample">
                <i class="fa-solid fa-search" aria-hidden="true"></i>
            </button>
            <button class="navbar-toggler navbar-toggler-right float-end toggle-menu ps-2 pe-0" [class.change]="isChange" type="button"
                style="width: max-content; height: max-content;"
                aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation"
                >
                <span class="navbar-toggler-bar burger-lines"></span>
                <span class="navbar-toggler-bar burger-lines"></span>
                <span class="navbar-toggler-bar burger-lines"></span>
            </button>
        </div>
        <div class="col-lg col-12 d-lg-flex justify-content-end collapse order-3 " id="action-button">
            <ng-content select="[actions]"></ng-content>
        </div>
    </div>
</nav>
<nav class="navbar page-nav navbar-default  py-0 navbar-expand-lg" *ngIf="pageData && pageData.N?.TM?.length">
    <div class="container-fluid ">
        <div>
            <ul class="nav navbar-nav navbar-left nav-tab-arrow">
                <li
                     routerLinkActive="active"
                    *ngFor="let tabMenu of pageData.N.TM; let index = index" class="nav-item  me-6">
                    <a class="nav-link  nav-link-arrow mb-0" style="cursor: pointer;"
                        [routerLink]="[`/menu/${tabMenu.U}`]"
                    >
                        {{tabMenu.T}}
                    </a>
 
                </li>
            </ul>

        </div>
    </div>
</nav>
<div class="main-panel-content">
    <div>
        <ng-content select="[content]"></ng-content>
    </div>
</div>